import WidgetModule from "@eisinc/Overrides/Widgets/ProductList/ProductListProductCard";

export * from "@eisinc/Overrides/Widgets/ProductList/ProductListProductCard";

export default WidgetModule;
